import type { RouteObject } from 'react-router';
import { SecurityPage } from './pages/SecurityPage';

export const SECURITY_ROUTES: RouteObject[] = [{ path: 'account/security', element: <SecurityPage /> }];
